import * as S from '@effect/schema/Schema';
export var StreakerBlockConfig = S.struct({
  typename: S.literal('StreakerBlock'),
  id: S.string,
  hash: S.string
});